export default __webpack_public_path__ + "static/media/bgSuvinil.debcc5c2.jpg";